import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    //获取banner信息列表
    GET_WECHAT_BANNER(data) {
        controller='Wechat';
        action='GetBanner';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改banner组件是否显示
    CHANGE_BANNER_SHOW(data) {
        controller='Wechat';
        action='ChangeBannerShow';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改banner的图片
    UPDATE_BANNER_IMAGE(data) {
        controller='Wechat';
        action='ChangeBannerImage';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改banner的图片名称
    CHANGE_BANNER_TYPENAME(data) {
        controller='Wechat';
        action='ChangeBannerTypeName';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改banner的图片是否显示
    CHANGE_BANNER_ISSHOW(data) {
        controller='Wechat';
        action='ChangeBannerIsShow';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改banner的图片排序序号
    CHANGE_BANNER_SORT(data) {
        controller='Wechat';
        action='ChangeBannerSort';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //删除图片信息
    DEL_BANNER(data) {
        controller='Wechat';
        action='DelBanner';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //获取Ad信息列表
    GET_WECHAT_AD(data) {
        controller='Wechat';
        action='GetAd';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改广告组件是否显示
    CHANGE_AD_SHOW(data) {
        controller='Wechat';
        action='ChangeAdShow';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改广告的图片
    UPDATE_AD_IMAGE(data) {
        controller='Wechat';
        action='ChangeAdImage';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改广告的图片是否显示
    CHANGE_AD_ISSHOW(data) {
        controller='Wechat';
        action='ChangeAdIsShow';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改AD的图片排序序号
    CHANGE_AD_SORT(data) {
        controller='Wechat';
        action='ChangeAdSort';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //删除图片信息
    DEL_AD(data) {
        controller='Wechat';
        action='DelAd';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //获取banner信息列表
    GET_WECHAT_CATE(data) {
        controller='Wechat';
        action='GetCate';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改banner的图片
    UPDATE_AD_IMAGE(data) {
        controller='Wechat';
        action='ChangeAdImage';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改分类组件是否显示
    CHANGE_CATE_SHOW(data) {
        controller='Wechat';
        action='ChangeCateShow';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改分类的图片
    UPDATE_CATE_IMAGE(data) {
        controller='Wechat';
        action='ChangeCateImage';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改分类的图片名称
    CHANGE_CATE_TYPENAME(data) {
        controller='Wechat';
        action='ChangeCateTypeName';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改分类的图片排序序号
    CHANGE_CATE_SORT(data) {
        controller='Wechat';
        action='ChangeCateSort';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改banner的图片是否显示
    CHANGE_CATE_ISSHOW(data) {
        controller='Wechat';
        action='ChangeCateIsShow';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //删除图片信息
    DEL_CATE(data) {
        controller='Wechat';
        action='DelCate';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //获取新增宠物信息是否显示
    GET_WECHAT_ADD_PET(data) {
        controller='Wechat';
        action='GetAddPet';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改新增宠物是否显示
    CHANGE_ADD_PET_SHOW(data) {
        controller='Wechat';
        action='ChangeAddPetShow';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //获取新增宠物计划
    GET_WECHAT_PLAN(data) {
        controller='Wechat';
        action='GetPlan';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改新增宠物是否显示
    CHANGE_PLAN_SHOW(data) {
        controller='Wechat';
        action='ChangePlanShow';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //获取footer信息列表
    GET_WECHAT_FOOTER(data) {
        controller='Wechat';
        action='GetFooter';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //更新footer信息图片
    UPDATE_FOOTER_IMAGE(data) {
        controller='Wechat';
        action='ChangeFooterImage';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改footer的图片名称
    CHANGE_FOOTER_TYPENAME(data) {
        controller='Wechat';
        action='ChangeFooterTypeName';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改footer的图片排序序号
    CHANGE_FOOTER_SORT(data) {
        controller='Wechat';
        action='ChangeFooterSort';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改footer的图片是否显示
    CHANGE_FOOTER_ISSHOW(data) {
        controller='Wechat';
        action='ChangeFooterIsShow';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //小程序数据显示
    GET_SETTING_INFOS(data) {
        controller='Wechat';
        action='GetSettingInfos';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //查看小程序是否开启/关闭
    GET_WECHAT_IS_OPEN(data) {
        controller='Wechat';
        action='GetWechatIsOpen';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

}